<template>
  <div
    class="zoom-on-hover"
    v-bind:class="{ zoomed }"
    @mousemove="move"
    @mouseenter="zoom"
    @mouseleave="unzoom"
  >
    <img class="def" ref="def" :src="imgDef" />
    <img class="zoom" ref="zoom" :src="imgZoom || imgDef" />
  </div>
</template>

<script>
export default {
  props: ["imgDef", "imgZoom", "scale", "disabled"],
  data: function() {
    return {
      scaleFactor: 1,
      resizeCheckInterval: null,
      zoomed: false
    };
  },
  methods: {
    pageOffset(el) {
      var rect = el.getBoundingClientRect(),
        scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
        scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      return {
        y: rect.top + scrollTop,
        x: rect.left + scrollLeft
      };
    },
    // touchzoom: function(event) {
    //   if (this.disabled) return;
    //   this.move(event);
    //   this.zoomed = !this.zoomed;
    // },
    zoom: function() {
      if (!this.disabled) this.zoomed = true;
    },
    unzoom: function() {
      if (!this.disabled) this.zoomed = false;
    },
    move: function(event) {
      if (this.disabled || !this.zoomed) return;
      var offset = this.pageOffset(this.$el);
      var zoom = this.$refs.zoom;
      var def = this.$refs.def;
      var relativeX = event.clientX - offset.x + window.pageXOffset;
      var relativeY = event.clientY - offset.y + window.pageYOffset;
      var defFactorX = relativeX / def.offsetWidth;
      var defFactorY = relativeY / def.offsetHeight;
      var x = defFactorX * (zoom.offsetWidth * this.scaleFactor - def.offsetWidth);
      var y = defFactorY * (zoom.offsetHeight * this.scaleFactor - def.offsetHeight);
      zoom.style.left = -x + "px";
      zoom.style.top = -y + "px";
    },
    initEventLoaded: function() {
      // emit the "loaded" event if all images have been loaded
      var promises = [this.$refs.zoom, this.$refs.def].map(function(image) {
        return new Promise(function(resolve, reject) {
          image.addEventListener("load", resolve);
          image.addEventListener("error", reject);
        });
      });
      var component = this;
      Promise.all(promises).then(function() {
        component.$emit("loaded");
      }, function (error) {
        console.error(error);
      });
    },
    initEventResized: function() {
      var def = this.$refs.def;
      var previousWidth = def.offsetWidth;
      var previousHeight = def.offsetHeight;
      var component = this;
      this.resizeCheckInterval = setInterval(function() {
        if ( previousWidth != def.offsetWidth || previousHeight != def.offsetHeight ) {
          previousWidth = def.offsetWidth;
          previousHeight = def.offsetHeight;
          component.$emit("resized", {
            width: def.width,
            height: def.height,
            fullWidth: def.naturalWidth,
            fullHeight: def.naturalHeight
          });
        }
      }, 1000);
    }
  },
  mounted: function() {
    if (this.$props.scale) {
      this.scaleFactor = parseInt(this.$props.scale);
      this.$refs.zoom.style.transform = "scale(" + this.scaleFactor + ")";
    }
    this.initEventLoaded();
    this.initEventResized();
  },
  updated: function() {
    this.initEventLoaded();
  },
  beforeDestroy: function() {
    this.resizeCheckInterval && clearInterval(this.resizeCheckInterval);
  }
};
</script>

<style>
  .zoom-on-hover { position: relative; overflow: hidden; }
  .zoom-on-hover .def { width: 100%; }
  .zoom-on-hover .zoom { position: absolute; opacity: 0; transform-origin: top left; }
  .zoom-on-hover.zoomed .zoom { opacity: 1; }
  .zoom-on-hover.zoomed .def { opacity: 0; }
  @media screen and (max-width: 768px) {
    .zoom-on-hover .zoom { display: none; }
    .zoom-on-hover.zoomed .zoom { opacity: 0; }
    .zoom-on-hover.zoomed .def { opacity: 1; }
  }
</style>
